import React, { useState } from 'react';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const SnackAlert = ({ message, open, handleClose, severity = 'error' }) => {
	return (
		<div>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				onClose={handleClose}
			>
				<Alert severity={severity} variant='filled' onClose={handleClose}>
					{message}
				</Alert>
			</Snackbar>
		</div>
	);
};

export default SnackAlert;
